var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.87501 30.6C1.34376 30.6 0.898756 30.4272 0.540006 30.0816C0.181257 29.736 0.00125646 29.3088 6.46551e-06 28.8C-0.00124353 28.2912 0.178757 27.864 0.540006 27.5184C0.901256 27.1728 1.34626 27 1.87501 27H3.75V14.4C3.75 11.91 4.53125 9.6978 6.09375 7.7634C7.65625 5.829 9.6875 4.5612 12.1875 3.96V2.7C12.1875 1.95 12.4613 1.3128 13.0087 0.788404C13.5562 0.264004 14.22 0.00120409 15 4.09091e-06C15.78 -0.00119591 16.4444 0.261604 16.9931 0.788404C17.5419 1.3152 17.815 1.9524 17.8125 2.7V3.96C20.3125 4.56 22.3437 5.8278 23.9062 7.7634C25.4687 9.699 26.25 11.9112 26.25 14.4V27H28.125C28.6562 27 29.1019 27.1728 29.4619 27.5184C29.8219 27.864 30.0012 28.2912 30 28.8C29.9987 29.3088 29.8187 29.7366 29.46 30.0834C29.1012 30.4302 28.6562 30.6024 28.125 30.6H1.87501ZM15 36C13.9688 36 13.0863 35.6478 12.3525 34.9434C11.6188 34.239 11.2513 33.3912 11.25 32.4H18.75C18.75 33.39 18.3831 34.2378 17.6494 34.9434C16.9156 35.649 16.0325 36.0012 15 36Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/NotificationIcon.b54166d2d0db5ed790cd67a734e3b50b.svg";
export { ForwardRef as ReactComponent };